import React, { PureComponent } from 'react';
import { createQboEstimate } from '../api/qbo-estimate';

export class QboClientExport extends PureComponent {
  public render(): JSX.Element {
    const searchParams = new URLSearchParams(window.location.search);

    const code = searchParams.get('code');
    const realmId = searchParams.get('realmId');
    const quipaClientId = Number(searchParams.get('state'));

    createQboEstimate({
      quipaClientId,
      code,
      realmId,
      qboClientId: '',
      redirectUri: `${window.location.origin}/qbo_client_export_oauth_redirect`,
    }).catch(console.error);

    window.setTimeout(() => {
      window.location.href = window.location.origin + `/clients/${quipaClientId}`;
    }, 5000);
    return <div>Exporting client data to QuickBooks Online ...</div>;
  }
}
